import axios from 'axios'
import {message, Modal, notification} from 'ant-design-vue'
import moment from 'moment'
import store from '../store'
import db from 'utils/localstorage'
import aesEncrypt from 'utils/aesEncrypt'
moment.locale('zh-cn')
let showError = false;
function checkStatus (response) {
  if (response.status === 200 || response.status === 304) {
    return response['data']
  } else {
      throw new Error(response.data.message); // eslint-disable-line
  }
  throw new Error(response.statusText); // eslint-disable-line
}

export function get (url, params) {
  // let queryData = Object.assign(params, {t: new Date().getTime()})
  return axios.get(url, {params}).then(checkStatus)
}

// 统一配置
let YTVUE_REQUEST = axios.create({
  baseURL: `${process.env.BACKEND_API_HOST}`,
  responseType: 'json',
  validateStatus (status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
})

// 拦截请求
YTVUE_REQUEST.interceptors.request.use((config) => {
  const current = new Date().getTime()
  const lastTime = db.get('RequestTime')
  if (lastTime) {
    config.headers['Request-Time'] = aesEncrypt.encrypt("" + lastTime)
  }
  db.save('RequestTime', current)
  if (store.state.account && store.state.account.user && store.state.account.user.id) {
    config.headers['User-Id'] = store.state.account.user.id
  }
  let expireTime = store.state.account.expireTime
  let now = moment().format('YYYYMMDDHHmmss')
  let locale = db.get('language') || 'zh-cn'
  // 让token早10秒种过期，提升“请重新登录”弹窗体验
  if (now - expireTime >= -10) {
    showError && Modal.error({
      title: locale === 'zh-cn' ? '登录已过期' : 'Login expired',
      content: locale === 'zh-cn' ? '很抱歉，登录已过期，请重新登录' : 'Sorry, your login has expired, please login again.',
      okText: locale === 'zh-cn' ? '重新登录' : 'Re-Login',
      mask: false,
      onOk: () => {
        return new Promise((resolve, reject) => {
          db.clear()
          location.reload()
        }).catch(function (reason) {
          console.log('catch:', reason)
        })
      }
    })
    showError = true
  } else {
    showError = false
  }
  // 有 token就带上
  if (store.state.account.token) {
    config.headers.Language = locale === 'zh-cn' ? 'zh_cn' : 'en_us'
    config.headers.Authentication = store.state.account.token
  }
  if (store.state.account.hospital) {
    config.headers.Authhospital = store.state.account.hospital
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// 拦截响应
YTVUE_REQUEST.interceptors.response.use((config) => {
  return config
}, (error) => {
  let locale = db.get('language') || 'zh-cn'
  if (error.response) {
    let errorMessage = error.response.data === null ? '系统内部异常，请联系网站管理员' : error.response.data.message
    switch (error.response.status) {
      case 404:
        notification.error({
          message: locale === 'zh-cn' ? '系统提示' : 'Error',
          description: locale === 'zh-cn' ? '很抱歉，资源未找到' : 'Sorry,resource not found',
          duration: 4
        })
        break
      case 403:
      case 401:
        !showError && Modal.error({
          title: locale === 'zh-cn' ? '系统提示' : 'Error',
          content: errorMessage.indexOf('::') > -1 ? (locale === 'zh-cn' ? errorMessage.split('::')[0] : errorMessage.split('::')[1]) : errorMessage,
          okText: locale === 'zh-cn' ? '重新登录' : 'Re-Login',
          mask: false,
          onOk: () => {
            return new Promise((resolve, reject) => {
              db.clear()
              location.reload()
            }).catch(function (reason) {
              console.log('catch:', reason)
            })
          }
        })
        // notification.warn({
        //   message: locale === 'zh-cn' ? '系统提示' : 'Error',
        //   description: errorMessage.indexOf('::') > -1 ? (locale === 'zh-cn' ? errorMessage.split('::')[0] : errorMessage.split('::')[1]) : errorMessage,
        //   duration: 4
        // })
        break
      default:
        notification.error({
          message: locale === 'zh-cn' ? '系统提示' : 'Error',
          description: errorMessage,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
})

const request = {
  post (url, params) {
    let contentType = (url.indexOf('login') > -1) || (url.indexOf('regist') > -1) || (url.indexOf('common/getAge') > -1) ? 'application/x-www-form-urlencoded' : 'application/json'
    return YTVUE_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        if (url.indexOf('login') > -1 || url.indexOf('regist') > -1 || url.indexOf('common/getAge') > -1) {
          Object.keys(params).forEach((key) => {
            if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
              result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
            }
          })
        } else {
          result = JSON.stringify(params)
        }
        return result
      }],
      headers: {
        'Content-Type': contentType
      }
    })
  },
  put (url, params) {
    let contentType = (url.indexOf('login') > -1 || url.indexOf('avatar') > -1 || url.indexOf('password') > -1 || url.indexOf('password/reset') > -1) ? 'application/x-www-form-urlencoded' : 'application/json'
    return YTVUE_REQUEST.put(url, params, {
      transformRequest: [(params) => {
        let result = ''
        if (url.indexOf('login') > -1 || url.indexOf('avatar') > -1 || url.indexOf('password') > -1 || url.indexOf('password/reset') > -1) {
          Object.keys(params).forEach((key) => {
            if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
              result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
            }
          })
        } else {
          result = JSON.stringify(params)
        }
        return result
      }],
      headers: {
        'Content-Type': contentType
      }
    })
  },
  get (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return YTVUE_REQUEST.get(`${url}${_params}`)
  },
  delete (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return YTVUE_REQUEST.delete(`${url}${_params}`)
  },
  export (url, params = {}) {
    message.loading('导出数据中')
    return YTVUE_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        // let result = ''
        // Object.keys(params).forEach((key) => {
        //   if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
        //     result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
        //   }
        // })
        return JSON.stringify(params)
      }],
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      const fileName = `${new Date().getTime()}_导出结果.xlsx`
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, fileName)
      }
    }).catch((r) => {
      console.error(r)
      message.error('导出失败')
    })
  },
  download (url, params, filename) {
    // message.loading('文件传输中')
    return YTVUE_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, filename)
      }
    }).catch((r) => {
      console.error(r)
      message.error('下载失败')
    })
  },
  upload (url, params) {
    return YTVUE_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  originalGet (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return axios.get(`${url}${_params}`)
  }
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js